export const MOCK_DATA_PRE_SUBSCRIPTION_DEFAULT = {
  header: {
    title: "One ticket, every competition",
    subtitlep1: "Our members",
    subtitlep2: "save up to 75%",
    subtitlep3: "by playing with **BOTB Pass**",
    video: "https://cdn.botb.com/media/pgiodpg4/ss5-desktop-1-1-1.mp4",
    videoMobile: "https://cdn.botb.com/media/1ofn5wgg/ss4-mobile-1-1-1.mp4",
    legalText: "*Savings shown relates to tickets in BOTB Pass yearly vs. buying tickets separately.",
  },
  features: [
    "Subscribe & never miss a draw again",
    "Up to £117 off vs. buying individual tickets",
    "£2.3M+ prize value across 21 competitions",
  ],
  offer: {
    headline: "Claim **£5 FREE** when joining:",
    bonus: "First 1,500 October subscribers get",
    description: "5 extra Dream Home tickets",
    offerImage: "https://cdn.botb.com/media/pgul424d/image-809-2-1.png",
    expireTime: 1759838400,
  },
};

export const MOCK_DATA_PRE_SUBSCRIPTION_NO_OFFER = {
  header: {
    title: "One ticket, every competition",
    subtitlep1: "Our members",
    subtitlep2: "save up to 75%*",
    subtitlep3: "by playing with BOTB Pass",
    video: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
    videoMobile: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
  },
  features: [
    "Subscribe & never miss a draw again",
    "Up to £117* off vs. buying individual tickets",
    "£2.3M+ prize value across 21 competitions",
  ],
};

export const MOCK_DATA_PRE_SUBSCRIPTION_NO_COUNTDOWN = {
  header: {
    title: "One ticket, every competition",
    subtitlep1: "Our members",
    "subtitle[2": "save up to 75%*",
    subtitlep3: "by playing with BOTB Pass",
    video: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
    videoMobile: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
  },
  features: [
    "Subscribe & never miss a draw again",
    "Up to £117* off vs. buying individual tickets",
    "£2.3M+ prize value across 21 competitions",
  ],
  offer: {
    headline: "Claim **£5** when joining:",
    bonus: "First 1,500 October subscribers get",
    description: "5 extra Dream House tickets",
    offerImage: "http://example.com",
  },
};
